import { useEffect, useState, useRef } from "react";
import "../assests/css/cursor.scss";

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [hovered, setHovered] = useState(false);
  const [touchHovered, setTouchHovered] = useState(false);
  const [visible, setVisible] = useState(true);
  const hideTimeout = useRef(null);

  useEffect(() => {
    const touchSupported =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    // Move cursor (mouse + touch)
    const moveCursor = (e) => {
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      const y = e.touches ? e.touches[0].clientY : e.clientY;
      setPosition({ x, y });

      if (touchSupported) setVisible(true);
    };

    // ======================
    // MOBILE EVENTS
    // ======================
    const handleTouchStart = (e) => {
      moveCursor(e);
      setVisible(true);

      // ✅ Show outer on ANY touch (press anywhere)
      setTouchHovered(true);

      if (hideTimeout.current) clearTimeout(hideTimeout.current);
    };

    const handleTouchMove = (e) => {
      moveCursor(e);

      // ✅ Keep outer active while dragging
      setTouchHovered(true);
    };

    const handleTouchEnd = () => {
      setTouchHovered(false);

      // ⏱ delay before hiding
      hideTimeout.current = setTimeout(() => {
        setVisible(false);
      }, 800);
    };

    // ======================
    // DESKTOP EVENTS
    // ======================
    const handleMouseOver = (e) => {
      const target = e.target.closest(
        "a, button, [role='button'], .cursor-pointer"
      );
      if (target) setHovered(true);
    };

    const handleMouseOut = (e) => {
      const target = e.target.closest(
        "a, button, [role='button'], .cursor-pointer"
      );
      if (target) setHovered(false);
    };

    // ======================
    // ADD LISTENERS
    // ======================
    if (touchSupported) {
      window.addEventListener("touchstart", handleTouchStart);
      window.addEventListener("touchmove", handleTouchMove);
      window.addEventListener("touchend", handleTouchEnd);
    } else {
      window.addEventListener("mousemove", moveCursor);
      document.addEventListener("mouseover", handleMouseOver);
      document.addEventListener("mouseout", handleMouseOut);
    }

    // ======================
    // CLEANUP
    // ======================
    return () => {
      if (touchSupported) {
        window.removeEventListener("touchstart", handleTouchStart);
        window.removeEventListener("touchmove", handleTouchMove);
        window.removeEventListener("touchend", handleTouchEnd);
      } else {
        window.removeEventListener("mousemove", moveCursor);
        document.removeEventListener("mouseover", handleMouseOver);
        document.removeEventListener("mouseout", handleMouseOut);
      }

      if (hideTimeout.current) clearTimeout(hideTimeout.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="custom-cursor-container"
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
    >
      <div className="cursor-inner"></div>

      {/* Outer circle */}
      {(hovered || touchHovered) && <div className="cursor-outer"></div>}
    </div>
  );
};

export default CustomCursor;
